import CompanyProfileDto from '@/models/Companies/CompanyProfileDto';
import LocationProfileDto from '@/models/Locations/LocationProfileDto';
import WorkerProfileDto from '@/models/Workers/WorkerProfileDto';
import BranchDto from '@/models/Branches/BranchDto';
import DeskDto from '@/models/Desks/DeskDto';
import DateTimeUtils from '@/lib/dateTimeUtils';

export default class FilterBookingRoleStatisticsViewModel {
    startAtFrom: string = DateTimeUtils.getThisMondayAsIso();
    companies: CompanyProfileDto[] = [];
    selectedCompany: CompanyProfileDto;
    locations: LocationProfileDto[] = [];
    selectedLocation: LocationProfileDto;
    desks: DeskDto[] = [];
    selectedDesk: DeskDto;
    branches: BranchDto[] = [];
    selectedBranch: BranchDto;
}